<template>
  <div class="auth-intro">
    <img
      v-if="merchantLogo"
      class="auth-intro__logo"
      :src="merchantLogo"
      :alt="getMerchant.name" />
    <p v-else class="auth-intro__brand">{{ getMerchant.name }}</p>
    <h2 class="auth-intro__title">{{ title }}</h2>
    <p v-if="subtitle" class="auth-intro__subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'AuthViewIntro',
    props: {
      title: {
        type: String,
        default: ''
      },
      subtitle: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapGetters(['getMerchant']),
      merchantLogo() {
        return this.getMerchant.image_url || '';
      }
    }
  }
</script>

<style scoped>
.auth-intro {
  margin-bottom: 20px;
  text-align: center;
}
.auth-intro__logo {
  height: 48px;
  max-width: 160px;
  margin: 0 auto 12px;
  object-fit: contain;
}
.auth-intro__brand {
  margin: 0 0 12px;
  font-size: 1rem;
  font-weight: 600;
  color: #1C2B36;
}
.auth-intro__title {
  margin: 0 0 6px;
  font-size: 1.375rem;
  font-weight: 600;
  color: #1C2B36;
}
.auth-intro__subtitle {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #6B7886;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/auth/AuthViewIntro.vue